var culture = '';
try {
    var pathName = location.pathname.split('/');

    culture = pathName[1];
} catch (err) {

}
var message1 = "امتیاز دهید";

if (culture === 'en') {
    message1 = "Rate it";
}

(function ($) {
    var defaults = {
        TotalNum: 5,
        firstRating: null,
        //=====
        getScore: true,
        setScore: false,
        getAndSet: false,
        //=====
        fontIcon: true,
        iclasses: {
            unselect: 'fa-circle-o',
            select: 'fa-dot-circle-o',
            halfIcon: 'fa fa-star-half-o'
        },
        //=====
        htmlelement: false,
        spanHeight: 20,
        spanWidth: 20,

        //=====
        writeScore: true,
        writeScoreOptions: {
            writeScoreText: message1
        },

        //======
        dynamicOption: false
    };

    $.fn.giveScore = function (options) {


        if (this.length == 0) {

            return this;
        }

        // support mutltiple elements

        if (this.length > 1) {

            this.each(function () {

                $(this).giveScore(options);

            });

            return this;
        }

        var settings = $.extend(true, {}, defaults, options);

        var base = $(this),
            rate1 = 0,
            baseRating, inputVal, objectLebgth, objectValue, objectText, oldTx,
            finalHtmlTags = '',
            //rateSystem = {},
            sc, tx = '';

        var scoreType, temp, selectedScoreNum, substr;

        var setup = function () {

            if (settings.firstRating != null) {
                inputVal = settings.firstRating;
            } else {
                inputVal = base.val();
            }

            base.after('<div class="scoresContainer"/>').hide();

            baseRating = base.next('.scoresContainer');

            baseRating.wrap('<div class="scoreWrapper" />');

            if (settings.fontIcon) {


                if (settings.dynamicOption) {

                    objectLebgth = base.children('option').length;

                    for (var l = 0; l < objectLebgth; l++) {

                        objectValue = base.children('option').eq(l).val();

                        objectText = base.children('option').eq(l).text();

                        finalHtmlTags += '<i data-value="' + objectValue + '"  data-text="' + objectText + '" class="fa ' + settings.iclasses.unselect + '"></i>';

                    };


                } else {

                    objectLebgth = settings.TotalNum;

                    for (var l = 0; l < objectLebgth; l++) {

                        finalHtmlTags += '<i class="fa ' + settings.iclasses.unselect + '"></i>';



                    };
                }

                baseRating.html(finalHtmlTags);

                if (settings.writeScore) {

                    baseRating.parent('.scoreWrapper').append('<a class="rate_Score">' + settings.writeScoreOptions.writeScoreText + '</a>');

                    scoreType = baseRating.parent().find('.rate_Score');

                }

                ///if use span
            } else if (settings.htmlelement) {

                if (settings.writeScore) baseRating.append('<span class="RateNume">' + inputVal + '</span>');

                for (var i = 0; i < settings.TotalNum; i++) {

                    finalHtmlTags += '<span  style="width:' +
                        (settings.spanWidth + 2) +
                        'px;height:' +
                        (settings.spanHeight + 2) +
                        'px" class="rateItem">';

                    var sel = '';

                    for (var j = 0; j < 10; j++) {

                        sel += '<i style="width:' + (settings.spanWidth / 10) + 'px"></i>';

                    };
                    finalHtmlTags += sel + '</span>';
                }

                baseRating.append(finalHtmlTags);

            }
        };

        var writeScore = function (value, text) {

            if (settings.dynamicOption) {

                if (text != undefined) {

                    baseRating.parent().find('.rate_Score').html(text);

                } else {

                    baseRating.parent().find('.rate_Score').html(message1);

                }


                baseRating.val(value);

            } else {

                switch (value) {

                    case 1: case 2: baseRating.parent().find('.rate_Score').html('بد');
                        break;

                    case 3: case 4: baseRating.parent().find('.rate_Score').html('خوب');
                        break;

                    case 5: case 6: baseRating.parent().find('.rate_Score').html('عالی');
                        break;
                }

            }

        }

        var init = function () {

            setup();

            if ((settings.getScore && !settings.setScore && !settings.htmlelement) || (settings.getAndSet && !settings.htmlelement)) {

                if (settings.getAndSet) {
                    baseRating.children().each(function (i) {

                        if (i < inputVal) {

                            $(this)
                                .attr('data-rating', '1')
                                .addClass(settings.iclasses.select)
                                .removeClass(settings.iclasses.unselect);
                        } else {
                            $(this)
                                .attr('data-rating', '0');
                        }
                    });
                    rate1 = 1;
                }

                baseRating.children().hover(

                    function () {

                        oldTx = $(this).closest('.scoreWrapper').find('.rate_Score').text();

                        $(this).prevAll().addBack().addClass(settings.iclasses.select).removeClass(settings.iclasses.unselect);

                        $(this).nextAll().removeClass(settings.iclasses.select).addClass(settings.iclasses.unselect);

                        if (settings.writeScore) {

                            if (settings.dynamicOption) {

                                sc = $(this).attr('data-value');

                                tx = $(this).attr('data-text');

                            } else {

                                sc = parseInt($(this).index(), 10) + 1;

                                tx = '';
                            }


                            writeScore(sc, tx);
                        }
                    },
                    function () {
                        if (rate1 === 0) {

                            $(this).prevAll().addBack().removeClass(settings.iclasses.select).addClass(settings.iclasses.unselect);

                            if (settings.writeScore) {

                                scoreType.html(settings.writeScoreOptions.writeScoreText);

                            }

                            //  tx = oldTx;

                        } else if (rate1 === 1) {

                            $(this).parent().children().each(function () {

                                if ($(this).attr('data-rating') === '0') {

                                    $(this).removeClass(settings.iclasses.select).addClass(settings.iclasses.unselect);;

                                } else {

                                    $(this).addClass(settings.iclasses.select).removeClass(settings.iclasses.unselect);
                                }
                            });
                            if (settings.writeScore) {

                                sc = parseInt(baseRating.find('.' + settings.iclasses.select).last().index(), 10) + 1;

                                if (settings.dynamicOption) {

                                    tx = baseRating.find('.' + settings.iclasses.select).last().attr('data-text');

                                }

                                writeScore(sc, tx);
                            }
                        }
                    });

                baseRating.children().click(function () {

                    $(this).prevAll().addBack().attr('data-rating', '1').addClass(settings.iclasses.select);

                    $(this).nextAll().attr('data-rating', '0');

                    $(this).nextAll().removeClass('fa-star');

                    rate1 = 1;

                    selectedScoreNum = baseRating.find('.' + settings.iclasses.select).length;

                    if (settings.writeScore) {

                        // sc = $(this).index();

                        writeScore(selectedScoreNum, $(this).attr('data-text'));
                    }

                    if (typeof inputVal !== typeof undefined && inputVal !== false) {
                        base.val(selectedScoreNum);
                    }

                });

            } else if (settings.setScore && !settings.getScore) {

                if (settings.htmlelement && !settings.fontIcon) {//html elem

                    //substr = temp.val().split('.');
                    inputVal = inputVal.split('.');

                    if (inputVal[0] > 0) {

                        baseRating.find('.rateItem').each(function (i) {

                            if (i < inputVal[0]) {

                                $(this).addClass('fillColor');
                            }
                        });
                        baseRating.find('.fillColor').last().next().addClass('min');
                    }
                    else if (inputVal[0] == 0 && inputVal[1] > 0) {

                        baseRating.find('.rateItem').first().addClass('min');
                    }
                    baseRating.find('.min>i').each(function (k) {

                        if (k < inputVal[1]) {

                            $(this).addClass('on');

                        }
                    });

                }

                else if (!settings.htmlelement && settings.fontIcon) {//font icon

                    if (isInt(Number(inputVal))) {

                        baseRating.children().each(function (i) {

                            if (i < inputVal) {

                                $(this)
                                    .attr('data-rating', '1')
                                    .addClass(settings.iclasses.select)
                                    .removeClass(settings.iclasses.unselect);
                            }


                        });
                    } else { // number is float
                        baseRating.children().each(function (i) {
                            var inputValRoundDown = Math.floor(inputVal);
                            if (i < inputValRoundDown) {
                                $(this)
                                    .attr('data-rating', '1')
                                    .addClass(settings.iclasses.select)
                                    .removeClass(settings.iclasses.unselect);
                            } else {
                                $(this)
                                    .attr('data-rating', '1')
                                    .addClass(settings.iclasses.halfIcon)
                                    .removeClass(settings.iclasses.unselect);
                                return false;
                            }
                        });

                    }

                }

            }
        }

        init();
        function isInt(n) {
            return Number(n) === n && n % 1 === 0;
        }

    }
})(jQuery);